<!-- Fullscreen Loading State -->
<ng-container *ngIf="type === 'fullscreen'">
  <!-- Loading State -->
  <div
    *ngIf="isLoading && !hasError"
    class="flex items-center justify-center h-screen bg-gray-50"
  >
    <div class="text-center loading-container">
      <!-- Modern Loading Spinner -->
      <div class="relative w-16 h-16 mx-auto mb-6">
        <div
          class="absolute inset-0 rounded-full border-4 border-gray-200"
        ></div>
        <div
          class="absolute inset-0 rounded-full border-4 border-primary border-t-transparent modern-spinner"
        ></div>
      </div>

      <!-- Loading Text -->
      <div class="space-y-2">
        <h3 class="text-lg font-medium text-gray-800">{{ loadingText }}</h3>
        <p *ngIf="loadingSubText" class="text-sm text-gray-500">
          {{ loadingSubText }}
        </p>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError" class="flex items-center justify-center h-screen">
    <div class="text-center p-8">
      <div class="text-red-500 mb-4">
        <svg
          class="w-16 h-16 mx-auto"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
          ></path>
        </svg>
      </div>
      <h2 class="text-xl font-semibold text-gray-800 mb-2">Loading Error</h2>
      <p class="text-gray-600 mb-4">{{ errorMessage }}</p>
      <button
        *ngIf="showRetryButton"
        class="px-4 py-2 bg-primary text-white rounded hover:bg-primary-600 transition-colors"
        (click)="onRetryClick()"
      >
        {{ retryButtonText }}
      </button>
    </div>
  </div>
</ng-container>

<!-- Inline/Mini Loading State -->
<ng-container *ngIf="type === 'inline' || type === 'mini'">
  <div
    *ngIf="isLoading && !hasError"
    class="flex items-center justify-center h-full"
  >
    <div class="text-center loading-container">
      <!-- Smaller Spinner for inline/mini -->
      <div
        [ngClass]="
          type === 'mini'
            ? 'relative w-8 h-8 mx-auto mb-3'
            : 'relative w-12 h-12 mx-auto mb-4'
        "
      >
        <div
          [ngClass]="
            type === 'mini'
              ? 'absolute inset-0 rounded-full border-2 border-gray-200'
              : 'absolute inset-0 rounded-full border-3 border-gray-200'
          "
        ></div>
        <div
          [ngClass]="
            type === 'mini'
              ? 'absolute inset-0 rounded-full border-2 border-primary border-t-transparent modern-spinner'
              : 'absolute inset-0 rounded-full border-3 border-primary border-t-transparent modern-spinner'
          "
        ></div>
      </div>
      <p
        [ngClass]="
          type === 'mini' ? 'text-sm text-gray-600' : 'text-base text-gray-600'
        "
      >
        {{ loadingSubText }}
      </p>
    </div>
  </div>

  <!-- Inline Error State -->
  <div *ngIf="hasError" class="flex items-center justify-center h-full">
    <div class="text-center p-4">
      <div class="text-red-500 mb-2">
        <svg
          [ngClass]="type === 'mini' ? 'w-8 h-8 mx-auto' : 'w-12 h-12 mx-auto'"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
          ></path>
        </svg>
      </div>
      <p
        [ngClass]="
          type === 'mini'
            ? 'text-sm text-gray-600 mb-2'
            : 'text-base text-gray-600 mb-3'
        "
      >
        {{ errorMessage }}
      </p>
      <button
        *ngIf="showRetryButton"
        [ngClass]="
          type === 'mini'
            ? 'px-3 py-1 text-sm bg-primary text-white rounded hover:bg-primary-600 transition-colors'
            : 'px-4 py-2 bg-primary text-white rounded hover:bg-primary-600 transition-colors'
        "
        (click)="onRetryClick()"
      >
        {{ retryButtonText }}
      </button>
    </div>
  </div>
</ng-container>
